module.exports = __webpack_public_path__ + "static/step-4.0e44a81f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/fetching/step-4.png
// module id = 2562
// module chunks = 116404443735450